import { all, spawn } from 'redux-saga/effects';
import proPMSaga from './sagas';

export default function* root() {
  yield all([spawn(proPMSaga)]);
}